<template>
    <div>
      <AccountComponent />
    </div>
  </template>
  
  <script>
  import AccountComponent from '@/components/AccountComponent.vue';
  
  export default {
    components: {
      AccountComponent
    }
  }
  </script>
  